// See: https://www.andiamo.co.uk/resources/iso-language-codes/
export enum LOCALE_CODE {
  EN_GB = 'en-gb',
  EN_AU = 'en-au',
  DE_AT = 'de-at',
  NL_BE = 'nl-be',
  FR_BE = 'fr-be',
  EN_CA = 'en-ca',
  FR_CA = 'fr-ca',
  DA = 'da',
  FR = 'fr',
  DE = 'de',
  EN_IE = 'en-ie',
  IT = 'it',
  NO = 'no',
  PL = 'pl',
  PT = 'pt',
  ES = 'es',
  SV = 'sv',
  DE_CH = 'de-ch',
  FR_CH = 'fr-ch',
  IT_CH = 'it-ch',
  NL = 'nl',
  EN_US = 'en-us',
  EN_NZ = 'en-nz',
  JA = 'ja',
}
